import React from 'react';
import { Trophy, Users, Lightbulb } from 'lucide-react';
import { achievements } from '../data/mock';

const iconMap = {
  0: Trophy,
  1: Users,
  2: Lightbulb
};

const Achievements = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#F2F2F2] grid-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">Recognition</span>
          <h2 className="section-title">Achievements</h2>
        </div>

        {/* Achievements Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {achievements.map((achievement, idx) => {
            const Icon = iconMap[idx] || Trophy;
            return (
              <div
                key={achievement.id}
                className="card-sharp p-8 group hover:bg-[#232323] transition-all duration-300"
              >
                <div className="mb-6">
                  <div className="w-14 h-14 bg-[#38FF62] flex items-center justify-center group-hover:bg-white transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#232323]" />
                  </div>
                </div>
                <h3 className="font-display text-xl font-semibold mb-3 group-hover:text-[#38FF62] transition-colors duration-300">
                  {achievement.title}
                </h3>
                <p className="font-body text-[rgba(35,35,35,0.7)] group-hover:text-[rgba(255,255,255,0.7)] transition-colors duration-300">
                  {achievement.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Achievements;